import CONF from '../utils/conf';
import u from '../utils/Utils';
import du from '../utils/dom-utilities';

/**
 * JS DOM move for mosaic A
 *
 * @param {HTMLElement} moz Mosaic node
 */
export function queryMosaicA(moz) {
    var verticalContainer = moz.querySelector('.js-mosaic__vertical-container');
    var mainContainer;
    var verticalTile;

    if (Modernizr.mq(`(min-width: ${u.em(CONF.mq.lg)}em)`)) {
        if (!verticalContainer.querySelector('.js-mosaic__vertical-tile')) {
            mainContainer = moz.querySelector('.mosaic__main-container');
            verticalTile = mainContainer.querySelector('.js-mosaic__vertical-tile');
            moveToContainer(verticalTile, verticalContainer);
        }

    } else {
        if (verticalContainer.querySelector('.js-mosaic__vertical-tile')) {
            mainContainer = moz.querySelector('.mosaic__main-container');
            verticalTile = verticalContainer.querySelector('.js-mosaic__vertical-tile');
            moveToContainer(verticalTile, mainContainer);
        }
    }
}

/**
 * JS DOM move for mosaic C
 *
 * @param {HTMLElement} moz Mosaic node
 */
export function queryMosaicC(moz) {
    var firstContainer = moz.querySelector('.js-mosaic-c__first-container');
    var lastContainer = moz.querySelector('.js-mosaic-c__last-container');
    var movingTile;

    if (Modernizr.mq(`(min-width: ${u.em(CONF.mq.sm)}em)`)) {
        if (lastContainer.querySelector('.js-mosaic-c__tile')) {
            movingTile = lastContainer.querySelector('.js-mosaic-c__tile');
            moveToContainer(movingTile, firstContainer);
        }

    } else {
        if (!lastContainer.querySelector('.js-mosaic-c__tile')) {
            movingTile = firstContainer.querySelector('.js-mosaic-c__tile');
            moveToContainer(movingTile, lastContainer);
        }
    }
}

/**
 * Move node
 *
 * @param {HTMLElement} el Node to move
 * @param {HTMLElement} destContainer Parent node container
 */
export function moveToContainer(el, destContainer) {
    var duplicateNode = el.cloneNode(true);
    el.parentNode.removeChild(el);
    destContainer.appendChild(duplicateNode);
}


/**
 * Active responsive moving node for mosaic type A and C
 */
export default function() {
    du.queryAll('.js-mosaic-a').forEach((item) => {
        queryMosaicA(item);
        window.addEventListener('optimized-resize', queryMosaicA.bind(this, item));
    });

    du.queryAll('.js-mosaic-c').forEach((item) => {
        queryMosaicC(item);
        window.addEventListener('optimized-resize', queryMosaicC.bind(this, item));
    });
}




// WEBPACK FOOTER //
// ./src/main/js/components/mosaic.js